// removed by extract-text-webpack-plugin
module.exports = {"navbar":"Menu__navbar___3qoih","hamburger":"Menu__hamburger___1p3_1","open":"Menu__open___27Iz1","menu":"Menu__menu___2w9pn","overlay":"Menu__overlay___1n8kf","net":"Menu__net___2SALI","fadeinOutD6":"Menu__fadeinOutD6___3mI2M","net1":"Menu__net1___1ncag","net2":"Menu__net2___2_mOC","net3":"Menu__net3___3JxMm","fadeinOutD13":"Menu__fadeinOutD13___2vkJq","menuinner":"Menu__menuinner___1HKXI","account":"Menu__account___147sy","index":"Menu__index___1MChX","magic":"Menu__magic___oklGA","workflow":"Menu__workflow___1jVHK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/Menu.scss
// module id = 2124
// module chunks = 14